module.exports = __webpack_public_path__ + "static/media/collaboration.6b34d331.png";